/* eslint-disable object-shorthand */
/* eslint-disable no-undef */

import domready from "domready";

import "@core/hello";
import MILL3_EMITTER from "@core/emitter";
import scrollbarWidth from "@core/scrollbar-width";
import Gate from "@ui/gate";
import Gdpr from "@ui/gdpr";
import GFormFactory from "@ui/gform";
import { chrome, edge, firefox, safari, ios, iphone, ipad, android } from "@utils/browser";
import { $, html } from "@utils/dom";

/*
 * Main app
 */
class App {
  constructor() {
    this.init();
  }

  init() {
    const browsers = [];

    if( chrome() ) browsers.push('chrome');
    if( edge() ) browsers.push('edge');
    if( firefox() ) browsers.push('firefox');
    if( safari() ) browsers.push('safari');
    if( ios() ) browsers.push('ios');
    if( iphone() ) browsers.push('iphone');
    if( ipad() ) browsers.push('ipad');
    if( android() ) browsers.push('android');

    // add browsers classnames on <html> in a single operation
    html.classList.add(...browsers);

    // set scrollbar width in css variables
    html.style.setProperty('--scrollbar-width', `${scrollbarWidth()}px`);

    // manually create and init GFormFactory because we don't use Windmill for Gate
    const gFormFactory = new GFormFactory( $('[data-ui*="gform"]'), MILL3_EMITTER );
          gFormFactory.init();
          gFormFactory.start();

    const gate = new Gate( $('[data-ui*="gate"]'), MILL3_EMITTER);
          gate.init();

    const gdpr = new Gdpr( $('[data-ui*="gdpr"]'), MILL3_EMITTER);
    gdpr.init();
  }
}

domready(() => {
  // import main styles in dev mode only
  if (process.env.NODE_ENV === "development") {
    import("../scss/Gate.scss").then(() => {
      setTimeout(() => {
        new App();
        import("./GridViewer");
        import("./FPSTracker");
      }, 500);
    });
  } else new App();
});
